import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PauseIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="pause" ref={ref} {...props}>
      <path d="M8,20.75A.76.76,0,0,1,7.25,20V4a.75.75,0,0,1,1.5,0V20A.76.76,0,0,1,8,20.75ZM16.75,20V4a.75.75,0,0,0-1.5,0V20a.75.75,0,0,0,1.5,0Z" />
    </Icon>
  ),
) as IconWithRender;

PauseIcon.displayName = 'PauseIcon';
PauseIcon.renderIcon = (props) => <PauseIcon {...props} />;
export default PauseIcon;
